export default "__VITE_ASSET__Ds7WkxCz__"